exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_label__n7Byj{color:#9e9e9e;font-size:.8125rem;font-weight:400;margin-bottom:.25rem}", ""]);

// exports
exports.locals = {
	"label": "style_label__n7Byj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/InputLabel/style.less
// module id = 1528
// module chunks = 8